export default __webpack_public_path__ + "static/media/37.972a52a4.png";